import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';
import {
    ADF_TRANSCEIVER,
    AIRCRAFT_STATION_INFORMATION,
    ATC_RECEIVER,
    ATC_TRANSMITTER,
    DME_RECEIVER,
    DME_TRANSMITTER,
    DOPPLER_NAV_TRANSCEIVER,
    EMERGENCY_RADIO_BEACON,
    GLIDE_SLOPE_TRANSCEIVER,
    GPS_RECEIVER,
    HF_TRANSCEIVER,
    MARKER_RECEIVER,
    OTHERS,
    RADIO_ALTIMETER_TRANSCEIVER,
    VHF_NAV_TRANSCEIVER,
    VHF_TRANSCEIVER,
    WEATHER_ALTIMETER_TRANSCEIVER,
    WEATHER_C_BAND,
    WEATHER_X_BAND
} from 'common/application.const/Licence/MyLicence/aircraftLicence';
import { LICENCE_DETAILS } from 'common/application.const/Licence/MyApplication/cancel-AircraftApplication';
import {
    EXPRESS_LETTER_SERVICES,
    OTHER_DETAILS,
    SUPPORTING_DOCUMENTS
} from 'common/application.const/Licence/MyLicence/expressLetter';
import commonPayload from '../common';
import { formatDateTo_ddMMyyyy } from 'utils/application.helpers';
import { BILLING_DETAILS } from 'common/application.const/Licence/contactDetails';


export const formatAircraft = async (licenceDetails: any, caseTypeID: any, application: any, transactionType: any) => {

    let licence;
    let newDocs;
    let newPayload;
    let docsLic;
    const billingData = commonPayload.getBillingData(licenceDetails);
    const contactPersonParticulars = commonPayload.getContactPersonParticulars(licenceDetails);
    const billingPersonParticulars = commonPayload.getBillingPersonParticulars(licenceDetails);

    const otherValues = licenceDetails?.OtherLICDetails?.map((value: Record<string, string>, index: number) => ({
        no: `${index + 1}`,
        typeEquipment: value?.typeOfEquipment ?? '',
        manufacturer: value?.manufacturer ?? '',
        model: value?.model ?? '',
        frequencyFrom: value?.frequencyFromMHz ?? '',
        frequencyTo: value?.frequencyToMHz ?? ''
    }));

    newDocs = await requestLicenceAttachment(licenceDetails?.LICSupportingDoc?.aCopyOfTheCivilAviationAuthorityOfSingapore, caseTypeID);
    newPayload = attachmentPayloadSetting([newDocs]);
    docsLic = attachmentRetrieve(newPayload);
    const HF_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'HF Transceiver',
            manufacturer: licenceDetails?.hfTransceiver?.manufacturer ?? '',
            model: licenceDetails?.hfTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.hfTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.hfTransceiver?.frequencyToMHz ?? ''
        }
    ];
    const VHF_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'VHF Transceiver',
            manufacturer: licenceDetails?.vhfTransceiver?.manufacturer ?? '',
            model: licenceDetails?.vhfTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.vhfTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.vhfTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const ADF_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'ADF Transceiver',
            manufacturer: licenceDetails?.adfTransceiver?.manufacturer ?? '',
            model: licenceDetails?.adfTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.adfTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.adfTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const EMERGENCY_RADIO_BEACON_TBL = [
        {
            typeEquipment: 'Emergency Radio Beacon',
            manufacturer: licenceDetails?.emergencyRadioBeacon?.manufacturer ?? '',
            model: licenceDetails?.emergencyRadioBeacon?.model ?? '',
            frequencyFrom: licenceDetails?.emergencyRadioBeacon?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.emergencyRadioBeacon?.frequencyToMHz ?? ''
        }
    ];

    const MARKER_RECEIVER_TBL = [
        {
            typeEquipment: 'Marker Receiver',
            manufacturer: licenceDetails?.markerReceiver?.manufacturer ?? '',
            model: licenceDetails?.markerReceiver?.model ?? '',
            frequencyFrom: licenceDetails?.markerReceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.markerReceiver?.frequencyToMHz ?? ''
        }
    ];

    const VHF_NAV_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'VHF NAV Transceiver',
            manufacturer: licenceDetails?.vhfTransceiver?.manufacturer ?? '',
            model: licenceDetails?.vhfTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.vhfTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.vhfTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const GLIDE_SLOPE_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'Glide Slope Transceiver',
            manufacturer: licenceDetails?.glideSlopeReceiver?.manufacturer ?? '',
            model: licenceDetails?.glideSlopeReceiver?.model ?? '',
            frequencyFrom: licenceDetails?.glideSlopeReceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.glideSlopeReceiver?.frequencyToMHz ?? ''
        }
    ];

    const DME_TRANSMITTER_TBL = [
        {
            typeEquipment: 'D.M.E Transmitter',
            manufacturer: licenceDetails?.dMETransmitter?.manufacturer ?? '',
            model: licenceDetails?.dMETransmitter?.model ?? '',
            frequencyFrom: licenceDetails?.dMETransmitter?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.dMETransmitter?.frequencyToMHz ?? ''
        }
    ];

    const DME_RECEIVER_TBL = [
        {
            typeEquipment: 'D.M.E Receiver',
            manufacturer: licenceDetails?.dMEReceiver?.manufacturer ?? '',
            model: licenceDetails?.dMEReceiver?.model ?? '',
            frequencyFrom: licenceDetails?.dMEReceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.dMEReceiver?.frequencyToMHz ?? ''
        }
    ];

    const ATC_TRANSMITTER_TBL = [
        {
            typeEquipment: 'A.T.C Transmitter',
            manufacturer: licenceDetails?.aTCTransmitter?.manufacturer ?? '',
            model: licenceDetails?.aTCTransmitter?.model ?? '',
            frequencyFrom: licenceDetails?.aTCTransmitter?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.aTCTransmitter?.frequencyToMHz ?? ''
        }
    ];

    const ATC_RECEIVER_TBL = [
        {
            typeEquipment: 'A.T.C Receiver',
            manufacturer: licenceDetails?.aTCReceiver?.manufacturer ?? '',
            model: licenceDetails?.aTCReceiver?.model ?? '',
            frequencyFrom: licenceDetails?.aTCReceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.aTCReceiver?.frequencyToMHz ?? ''
        }
    ];

    const WEATHER_C_BAND_TBL = [
        {
            typeEquipment: 'Weather Radar Transceiver C Band',
            manufacturer: licenceDetails?.weatherRadarTransceiverCBand?.manufacturer ?? '',
            model: licenceDetails?.weatherRadarTransceiverCBand?.model ?? '',
            frequencyFrom: licenceDetails?.weatherRadarTransceiverCBand?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.weatherRadarTransceiverCBand?.frequencyToMHz ?? ''
        }
    ];

    const WEATHER_X_BAND_TBL = [
        {
            typeEquipment: 'Weather Radar Transceiver X Band',
            manufacturer: licenceDetails?.weatherRadarTransceiverXBand?.manufacturer ?? '',
            model: licenceDetails?.weatherRadarTransceiverXBand?.model ?? '',
            frequencyFrom: licenceDetails?.weatherRadarTransceiverXBand?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.weatherRadarTransceiverXBand?.frequencyToMHz ?? ''
        }
    ];

    const WEATHER_ALTIMETER_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'Weather Altimeter Transceiver',
            manufacturer: licenceDetails?.weatherAltimeterTransceiver?.manufacturer ?? '',
            model: licenceDetails?.weatherAltimeterTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.weatherAltimeterTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.weatherAltimeterTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const DOPPLER_NAV_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'Doppler Nav Transceiver',
            manufacturer: licenceDetails?.dopplerNavTransceiver?.manufacturer ?? '',
            model: licenceDetails?.dopplerNavTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.dopplerNavTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.dopplerNavTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const RADIO_ALTIMETER_TRANSCEIVER_TBL = [
        {
            typeEquipment: 'Radio Altimeter Transceiver',
            manufacturer: licenceDetails?.radioAltimeterTransceiver?.manufacturer ?? '',
            model: licenceDetails?.radioAltimeterTransceiver?.model ?? '',
            frequencyFrom: licenceDetails?.radioAltimeterTransceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.radioAltimeterTransceiver?.frequencyToMHz ?? ''
        }
    ];

    const GPS_RECEIVER_TBL = [
        {
            typeEquipment: 'GPS Receiver',
            manufacturer: licenceDetails?.gpsReceiver?.manufacturer ?? '',
            model: licenceDetails?.gpsReceiver?.model ?? '',
            frequencyFrom: licenceDetails?.gpsReceiver?.frequencyFromMHz ?? '',
            frequencyTo: licenceDetails?.gpsReceiver?.frequencyToMHz ?? ''
        }
    ];
    const tableData = [
        ...HF_TRANSCEIVER_TBL,
        ...VHF_TRANSCEIVER_TBL,
        ...ADF_TRANSCEIVER_TBL,
        ...EMERGENCY_RADIO_BEACON_TBL,
        ...MARKER_RECEIVER_TBL,
        ...VHF_NAV_TRANSCEIVER_TBL,
        ...GLIDE_SLOPE_TRANSCEIVER_TBL,
        ...DME_TRANSMITTER_TBL,
        ...DME_RECEIVER_TBL,
        ...ATC_TRANSMITTER_TBL,
        ...ATC_RECEIVER_TBL,
        ...WEATHER_C_BAND_TBL,
        ...WEATHER_X_BAND_TBL,
        ...WEATHER_ALTIMETER_TRANSCEIVER_TBL,
        ...DOPPLER_NAV_TRANSCEIVER_TBL,
        ...RADIO_ALTIMETER_TRANSCEIVER_TBL,
        ...GPS_RECEIVER_TBL
    ];
    licence = {
        id: 'aircraft-licence',
        formID: 'aircraft-licence',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
        values: {
            [`${OTHER_DETAILS}-usedOfSystem`]: licenceDetails?.otherDetails?.proposedUseOfSystem ?? '',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '',
            ...contactPersonParticulars,
            ...billingPersonParticulars,
            ...billingData,

            [`${EXPRESS_LETTER_SERVICES}-types-express-letter`]:
                licenceDetails?.expressLetterServices?.typeOfExpressLetterServices ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-callSign`]: licenceDetails?.aircraftStationInformation?.callSign ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-aircraftCategory`]: licenceDetails?.aircraftStationInformation?.aircraftCategory ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-aircraftRegistrationNo`]:
                licenceDetails?.aircraftStationInformation?.aircraftRegistrationNo ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-aircraftType`]: licenceDetails?.aircraftStationInformation?.aircraftType ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-aircraftSerialNo`]: licenceDetails?.aircraftStationInformation?.aircraftSerialNo ?? '',
            [`${AIRCRAFT_STATION_INFORMATION}-aircraftSelectiveCallNo`]:
                licenceDetails?.aircraftStationInformation?.aircraftSelectiveCallNo ?? '',
            [`${HF_TRANSCEIVER}-manufacturer`]: licenceDetails?.hfTransceiver?.manufacturer ?? '',

            [`${HF_TRANSCEIVER}-model`]: licenceDetails?.hfTransceiver?.model ?? '',
            [`${HF_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.hfTransceiver?.frequencyFromMHz ?? '',
            [`${HF_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.hfTransceiver?.frequencyToMHz ?? '',

            [`${VHF_TRANSCEIVER}-manufacturer`]: licenceDetails?.vhfTransceiver?.manufacturer ?? '',
            [`${VHF_TRANSCEIVER}-model`]: licenceDetails?.vhfTransceiver?.model ?? '',
            [`${VHF_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.vhfTransceiver?.frequencyFromMHz ?? '',
            [`${VHF_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.vhfTransceiver?.frequencyToMHz ?? '',

            [`${ADF_TRANSCEIVER}-manufacturer`]: licenceDetails?.adfTransceiver?.manufacturer ?? '',
            [`${ADF_TRANSCEIVER}-model`]: licenceDetails?.adfTransceiver?.model ?? '',
            [`${ADF_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.adfTransceiver?.frequencyFromMHz ?? '',
            [`${ADF_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.adfTransceiver?.frequencyToMHz ?? '',

            [`${EMERGENCY_RADIO_BEACON}-manufacturer`]: licenceDetails?.emergencyRadioBeacon?.manufacturer ?? '',
            [`${EMERGENCY_RADIO_BEACON}-model`]: licenceDetails?.emergencyRadioBeacon?.model ?? '',
            [`${EMERGENCY_RADIO_BEACON}-hfFrequencyFrom`]: licenceDetails?.emergencyRadioBeacon?.frequencyFromMHz ?? '',
            [`${EMERGENCY_RADIO_BEACON}-hfFrequencyTo`]: licenceDetails?.emergencyRadioBeacon?.frequencyToMHz ?? '',

            [`${MARKER_RECEIVER}-manufacturer`]: licenceDetails?.markerReceiver?.manufacturer ?? '',
            [`${MARKER_RECEIVER}-model`]: licenceDetails?.markerReceiver?.model ?? '',
            [`${MARKER_RECEIVER}-hfFrequencyFrom`]: licenceDetails?.markerReceiver?.frequencyFromMHz ?? '',
            [`${MARKER_RECEIVER}-hfFrequencyTo`]: licenceDetails?.markerReceiver?.frequencyToMHz ?? '',

            [`${VHF_NAV_TRANSCEIVER}-manufacturer`]: licenceDetails?.vhfTransceiver?.manufacturer ?? '',
            [`${VHF_NAV_TRANSCEIVER}-model`]: licenceDetails?.vhfTransceiver?.model ?? '',
            [`${VHF_NAV_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.vhfTransceiver?.frequencyFromMHz ?? '',
            [`${VHF_NAV_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.vhfTransceiver?.frequencyToMHz ?? '',

            [`${GLIDE_SLOPE_TRANSCEIVER}-manufacturer`]: licenceDetails?.glideSlopeReceiver?.manufacturer ?? '',
            [`${GLIDE_SLOPE_TRANSCEIVER}-model`]: licenceDetails?.glideSlopeReceiver?.model ?? '',
            [`${GLIDE_SLOPE_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.glideSlopeReceiver?.frequencyFromMHz ?? '',
            [`${GLIDE_SLOPE_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.glideSlopeReceiver?.frequencyToMHz ?? '',

            [`${DME_TRANSMITTER}-manufacturer`]: licenceDetails?.dMETransmitter?.manufacturer ?? '',
            [`${DME_TRANSMITTER}-model`]: licenceDetails?.dMETransmitter?.model ?? '',
            [`${DME_TRANSMITTER}-hfFrequencyFrom`]: licenceDetails?.dMETransmitter?.frequencyFromMHz ?? '',
            [`${DME_TRANSMITTER}-hfFrequencyTo`]: licenceDetails?.dMETransmitter?.frequencyToMHz ?? '',

            [`${DME_RECEIVER}-manufacturer`]: licenceDetails?.dMEReceiver?.manufacturer ?? '',
            [`${DME_RECEIVER}-model`]: licenceDetails?.dMEReceiver?.model ?? '',
            [`${DME_RECEIVER}-hfFrequencyFrom`]: licenceDetails?.dMEReceiver?.frequencyFromMHz ?? '',
            [`${DME_RECEIVER}-hfFrequencyTo`]: licenceDetails?.dMEReceiver?.frequencyToMHz ?? '',

            [`${ATC_TRANSMITTER}-manufacturer`]: licenceDetails?.aTCTransmitter?.manufacturer ?? '',
            [`${ATC_TRANSMITTER}-model`]: licenceDetails?.aTCTransmitter?.model ?? '',
            [`${ATC_TRANSMITTER}-hfFrequencyFrom`]: licenceDetails?.aTCTransmitter?.frequencyFromMHz ?? '',
            [`${ATC_TRANSMITTER}-hfFrequencyTo`]: licenceDetails?.aTCTransmitter?.frequencyToMHz ?? '',

            [`${ATC_RECEIVER}-manufacturer`]: licenceDetails?.aTCReceiver?.manufacturer ?? '',
            [`${ATC_RECEIVER}-model`]: licenceDetails?.aTCReceiver?.model ?? '',
            [`${ATC_RECEIVER}-hfFrequencyFrom`]: licenceDetails?.aTCReceiver?.frequencyFromMHz ?? '',
            [`${ATC_RECEIVER}-hfFrequencyTo`]: licenceDetails?.aTCReceiver?.frequencyToMHz ?? '',

            [`${WEATHER_C_BAND}-manufacturer`]: licenceDetails?.weatherRadarTransceiverCBand?.manufacturer ?? '',
            [`${WEATHER_C_BAND}-model`]: licenceDetails?.weatherRadarTransceiverCBand?.model ?? '',
            [`${WEATHER_C_BAND}-hfFrequencyFrom`]: licenceDetails?.weatherRadarTransceiverCBand?.frequencyFromMHz ?? '',
            [`${WEATHER_C_BAND}-hfFrequencyTo`]: licenceDetails?.weatherRadarTransceiverCBand?.frequencyToMHz ?? '',

            [`${WEATHER_X_BAND}-manufacturer`]: licenceDetails?.weatherRadarTransceiverXBand?.manufacturer ?? '',
            [`${WEATHER_X_BAND}-model`]: licenceDetails?.weatherRadarTransceiverXBand?.model ?? '',
            [`${WEATHER_X_BAND}-hfFrequencyFrom`]: licenceDetails?.weatherRadarTransceiverXBand?.frequencyFromMHz ?? '',
            [`${WEATHER_X_BAND}-hfFrequencyTo`]: licenceDetails?.weatherRadarTransceiverXBand?.frequencyToMHz ?? '',

            [`${WEATHER_ALTIMETER_TRANSCEIVER}-manufacturer`]: licenceDetails?.weatherAltimeterTransceiver?.manufacturer ?? '',
            [`${WEATHER_ALTIMETER_TRANSCEIVER}-model`]: licenceDetails?.weatherAltimeterTransceiver?.model ?? '',
            [`${WEATHER_ALTIMETER_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.weatherAltimeterTransceiver?.frequencyFromMHz ?? '',
            [`${WEATHER_ALTIMETER_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.weatherAltimeterTransceiver?.frequencyToMHz ?? '',

            [`${DOPPLER_NAV_TRANSCEIVER}-manufacturer`]: licenceDetails?.dopplerNavTransceiver?.manufacturer ?? '',
            [`${DOPPLER_NAV_TRANSCEIVER}-model`]: licenceDetails?.dopplerNavTransceiver?.model ?? '',
            [`${DOPPLER_NAV_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.dopplerNavTransceiver?.frequencyFromMHz ?? '',
            [`${DOPPLER_NAV_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.dopplerNavTransceiver?.frequencyToMHz ?? '',

            [`${RADIO_ALTIMETER_TRANSCEIVER}-manufacturer`]: licenceDetails?.radioAltimeterTransceiver?.manufacturer ?? '',
            [`${RADIO_ALTIMETER_TRANSCEIVER}-model`]: licenceDetails?.radioAltimeterTransceiver?.model ?? '',
            [`${RADIO_ALTIMETER_TRANSCEIVER}-hfFrequencyFrom`]: licenceDetails?.radioAltimeterTransceiver?.frequencyFromMHz ?? '',
            [`${RADIO_ALTIMETER_TRANSCEIVER}-hfFrequencyTo`]: licenceDetails?.radioAltimeterTransceiver?.frequencyToMHz ?? '',

            [`${GPS_RECEIVER}-manufacturer`]: licenceDetails?.gpsReceiver?.manufacturer ?? '',
            [`${GPS_RECEIVER}-model`]: licenceDetails?.gpsReceiver?.model ?? '',
            [`${GPS_RECEIVER}-hfFrequencyFrom`]: licenceDetails?.gpsReceiver?.frequencyFromMHz ?? '',
            [`${GPS_RECEIVER}-hfFrequencyTo`]: licenceDetails?.gpsReceiver?.frequencyToMHz ?? '',

            [`${OTHERS}-other`]: [
                ...(application !== 'IMDA-IRIS-Work-LICApplication' && tableData ? tableData : []),
                ...(otherValues || [{ no: '', typeEquipment: '', manufacturer: '', model: '', frequencyFrom: '', frequencyTo: '' }])
            ],
            [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
        }
    };
    if (transactionType === 'Cancel') {
        newDocs = await requestLicenceAttachment(
            licenceDetails?.supportingDocuments?.supportingDocumentsToSupportTheReasonsForCancellation,
            caseTypeID
        );
        newPayload = attachmentPayloadSetting([newDocs]);
        docsLic = attachmentRetrieve(newPayload);
        licence = {
            id: 'cancel-aircraft-licence',
            formID: 'cancel-aircraft-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.registrationNoUenOther ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNo ?? '',

                [`${LICENCE_DETAILS}-cancellationReason`]: licenceDetails?.cancellationInformation?.cancellationReason ?? '',
                [`${LICENCE_DETAILS}-effectiveDateOfCancellation`]:
                    formatDateTo_ddMMyyyy(licenceDetails?.cancellationInformation?.effectiveDateOfCancellation) ?? '',

                [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }
    if (transactionType === 'Renew') {
        licence = {
            id: 'renew-aircraft-licence',
            formID: 'renew-aircraft-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceParticular?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceParticular?.registrationNoUenOther ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceRenewal?.licenceNumber ?? '',

                [`${LICENCE_DETAILS}-invoiceNo`]: licenceDetails?.licenceRenewal?.invoiceNumber ?? '',
                [`${LICENCE_DETAILS}-renewalAmount`]: licenceDetails?.licenceRenewal?.renewalAmount ?? '',
                [`${LICENCE_DETAILS}-giroIndicator`]: licenceDetails?.licenceRenewal?.giroIndicator ?? '',
                [`${LICENCE_DETAILS}-dateOfExpiry`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.dateOfExpiry) ?? '',
                [`${LICENCE_DETAILS}-paymentDueDate`]: formatDateTo_ddMMyyyy(licenceDetails?.licenceRenewal?.paymentDueDate) ?? '',
                [`${LICENCE_DETAILS}-renewalPeriod`]: licenceDetails?.licenceRenewal?.renewalPeriod ?? ''
            }
        };
    }
    if (transactionType === 'Amend') {
        newDocs = await requestLicenceAttachment(
            licenceDetails?.supportingDocuments?.supportingDocumentsToSupportTheAmendmentApplication,
            caseTypeID
        );
        newPayload = attachmentPayloadSetting([newDocs]);
        docsLic = attachmentRetrieve(newPayload);
        const mapped = licenceDetails?.licenceDetails?.iWantToAmend.map((data: { [key: string]: string }) => {
            return {
                type: data.mixedValue
            };
        });
        licence = {
            id: 'amend-aircraft-licence',
            formID: 'amend-aircraft-licence',
            hasError: true,
            title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Station and Equipment Details',
            values: {
                [`${LICENCE_DETAILS}-licensee-nric`]: licenceDetails?.licenceDetails?.licenseeNric ?? '',
                [`${LICENCE_DETAILS}-registration-no-uen-other`]: licenceDetails?.licenceDetails?.registrationNoUenOther ?? '',
                [`${LICENCE_DETAILS}-licence-no`]: licenceDetails?.licenceDetails?.licenceNo ?? '',
                [`${LICENCE_DETAILS}-amend-table`]: [...mapped],

                [`${LICENCE_DETAILS}-name`]: licenceDetails?.correspondencePersonParticulars?.name ?? '',
                [`${LICENCE_DETAILS}-designation`]: licenceDetails?.correspondencePersonParticulars?.designation ?? '',
                [`${LICENCE_DETAILS}-officeTelNumber`]: licenceDetails?.correspondencePersonParticulars?.officeTelNumber ?? '',
                [`${LICENCE_DETAILS}-mobileNumber`]: licenceDetails?.correspondencePersonParticulars?.mobileNumber ?? '',
                [`${LICENCE_DETAILS}-email`]: licenceDetails?.correspondencePersonParticulars?.email ?? '',

                [`${LICENCE_DETAILS}-addressType`]: licenceDetails?.correspondenceAddress?.addressType ?? '',
                [`${LICENCE_DETAILS}-postalCode`]: licenceDetails?.correspondenceAddress?.address.postalCode ?? '',
                [`${LICENCE_DETAILS}-blockNo`]: licenceDetails?.correspondenceAddress?.address.blockNo ?? '',
                [`${LICENCE_DETAILS}-streetName`]: licenceDetails?.correspondenceAddress?.address.streetName ?? '',
                [`${LICENCE_DETAILS}-buildingName`]: licenceDetails?.correspondenceAddress?.address.buildingName ?? '',
                [`${LICENCE_DETAILS}-floor`]: licenceDetails?.correspondenceAddress?.address.floor ?? '',
                [`${LICENCE_DETAILS}-unit`]: licenceDetails?.correspondenceAddress?.address.unit ?? '',

                [`${LICENCE_DETAILS}-foreignAddress1`]: licenceDetails?.correspondenceAddress?.foreignAddress1 ?? '',
                [`${LICENCE_DETAILS}-foreignAddress2`]: licenceDetails?.correspondenceAddress?.foreignAddress2 ?? '',
                [`${LICENCE_DETAILS}-foreignAddress3`]: licenceDetails?.correspondenceAddress?.foreignAddress3 ?? '',
                [`${LICENCE_DETAILS}-zipCode`]: licenceDetails?.correspondenceAddress?.zipCode ?? '',

                [`${BILLING_DETAILS}-sameAsCorrespondencePersonParticulars`]:
                    licenceDetails?.billingPersonParticulars?.sameAsCorrespondencePersonParticulars ?? '',
                [`${BILLING_DETAILS}-name`]: licenceDetails?.billingPersonParticulars?.name ?? '',
                [`${BILLING_DETAILS}-designation`]: licenceDetails?.billingPersonParticulars?.designation ?? '',
                [`${BILLING_DETAILS}-officeTelNumber`]: licenceDetails?.billingPersonParticulars?.officeTelNumber ?? '',
                [`${BILLING_DETAILS}-mobileNumber`]: licenceDetails?.billingPersonParticulars?.mobileNumber ?? '',
                [`${BILLING_DETAILS}-email`]: licenceDetails?.billingPersonParticulars?.email ?? '',
                [`${BILLING_DETAILS}-notifyViaEmailForFutureLicenceRenewal`]:
                    licenceDetails?.billingPersonParticulars?.notifyViaEmailForFutureLicenceRenewal ?? '',

                [`${BILLING_DETAILS}-postalCode`]: licenceDetails?.billingAddress?.address.postalCode ?? '',
                [`${BILLING_DETAILS}-blockNo`]: licenceDetails?.billingAddress?.address.blockNo ?? '',
                [`${BILLING_DETAILS}-streetName`]: licenceDetails?.billingAddress?.address.streetName ?? '',
                [`${BILLING_DETAILS}-buildingName`]: licenceDetails?.billingAddress?.address.buildingName ?? '',
                [`${BILLING_DETAILS}-floor`]: licenceDetails?.billingAddress?.address.floor ?? '',
                [`${BILLING_DETAILS}-unit`]: licenceDetails?.billingAddress?.address.unit ?? '',

                [`${SUPPORTING_DOCUMENTS}-supporting-documents`]: newDocs ? docsLic : undefined
            }
        };
    }
    return licence;
}

const aircraftPayload = {
    formatAircraft
};

export default aircraftPayload;